import { request } from "@/utils/request"

const url = {
  api: '/appeditor/apimanage/',
}

/**
 * 查询接口列表
 * @param {*} params 
 */
export function getApiList(params) {
  return request({
    url: url.api + 'list',
    method: 'get',
    params
  })
}

/**
 * 获取接口详情
 * @param {*} id 
 * @returns 
 */
export function getApiDetail(id) {
  return request({
    url: url.api + id,
    method: 'get'
  })
}

/**
 * 保存接口信息
 * @param {*} data 
 */
export function saveApi(data) {
  return request({
    url: url.api + 'saveDetail',
    method: 'post',
    data
  })
}

/**
 * 删除项目接口数据
 * @param {*} ids 
 */
export function deleteApiByIds(ids) {
  return request({
    url: url.api + 'deleteByIds',
    method: 'post',
    data: ids
  })
}